export const PORTAL_TYPE_YF = 'yf'
export const PORTAL_TYPE_RJA = 'rja'
export const PORTAL_TYPE_FPO = 'fpo'

export const PORTAL_TYPES = [
  PORTAL_TYPE_YF,
  PORTAL_TYPE_RJA,
  PORTAL_TYPE_FPO
]

export const FEATURE_SHOW_SINGLE_PAGE_SEARCH_JOB_VIEW = 'show_single_page_search_job_view'

export const CM_FB_VENDOR = 's7'
export const CM_TWITTER_VENDOR = 's34'
export const CM_YOUTUBE_VENDOR = 's30'
export const CM_GOOGLE_MAPS_VENDOR = 's1104'

export const KUNUNU_WIDGET_LIST_TYPE = 'kununu_list'
export const KUNUNU_WIDGET_DETAIL_TYPE = 'kununu_detail'
